import React, { useCallback, useEffect } from 'react';
import { app } from '@microsoft/teams-js';
import { useSearchParams } from 'react-router';
import { useAppContext } from '../../model';
import { useAppDispatch, useSelector } from '../../store/hooks';
import {
    addConversationNoteThunk,
    loadConversationNotes,
    removeConversationNoteThunk,
    selectConversationNotes,
} from '../../store/features/activeConversations/activeConversationsSlice';
import { ConversationNotesDialog } from '../ActiveConversationsPage/ConversationNotes/ConversationNotesDialog';

const ConversationNotesPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const conversationId = searchParams.get('conversationId');
    const dispatch = useAppDispatch();
    const { teamsContext } = useAppContext();
    const conversationNotes = useSelector(selectConversationNotes);

    useEffect(() => {
        if (conversationId) {
            dispatch(loadConversationNotes(conversationId));
        }

        app.notifySuccess();
    }, [conversationId, dispatch]);

    const handleAddConversationNote = useCallback(
        async (note: string) => {
            if (!conversationId) return;

            await dispatch(
                addConversationNoteThunk({ conversationId, note })
            ).unwrap();
        },
        [conversationId, dispatch]
    );

    const handleDeleteConversationNote = useCallback(
        async (noteId: string) => {
            if (!conversationId) return;

            await dispatch(
                removeConversationNoteThunk({ conversationId, noteId })
            ).unwrap();
        },
        [conversationId, dispatch]
    );

    return (
        <ConversationNotesDialog
            open
            embedded
            notes={conversationNotes.data}
            loading={conversationNotes.loading}
            error={conversationId ? conversationNotes.error : 'Invalid conversation'}
            currentUserId={teamsContext?.user?.id}
            onClose={() => undefined}
            onSubmit={handleAddConversationNote}
            onDelete={handleDeleteConversationNote}
        />
    );
};

export default ConversationNotesPage;
